export const FILINGS_URL_PREFIX = 'https://www.sec.gov/Archives/edgar/data/'
export const FILINGS_URL_PREFIX_INTERACTIVE = 'https://www.sec.gov/ix?doc=/Archives/edgar/data/'
